var collectionSortEvt = new CustomEvent("collectionSort"),
    initFiltersEvt = new CustomEvent("initFilters"),
    collectionLoadMoreEvt = new CustomEvent("collectionLoadMore"),
    collectionSeoUpdate = new CustomEvent("collectionSeoUpdate"),
    navAsideEvt = new CustomEvent("navAside"),
    filtersEvt = new CustomEvent("filters"),
    rangeSliderEvt = new CustomEvent("rangeSlider");

// Collectionpage: sort_by
const initCollectionSort = (container = document) => {
  var sort_by = container.id === 'sort_by' ? container : container.querySelector('#sort_by'),
      sort_by_clone = container.getElementsByClassName('sort_by_clone')[0];
  if (sort_by != null) {
    if (sort_by.dataset.initialized) return;
    sort_by.dataset.initialized = 'true';

    Shopify.queryParams = [];
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams.push({
            key: decodeURIComponent(aKeyValue[0]),
            value: decodeURIComponent(aKeyValue[1])
          });
        }
      }
    }
    sort_by.addEventListener('change', function() {
      var el = this;
      if (sort_by_clone != null) { sort_by_clone.value == el.value; }
      setTimeout(function () {
        function findIndexByProperty(data, key, value) {
          for (var i = 0; i < data.length; i++) {
            if (data[i][key] == value) {
              return i;
            }
          }
          return -1;
        }
        var sort_by =  {
          key: 'sort_by',
          value: el.value
        };
        var sort_by_index = findIndexByProperty(Shopify.queryParams, 'key', 'sort_by');
        if (sort_by_index > -1) {
          Shopify.queryParams[sort_by_index] = sort_by;
        } else {
          Shopify.queryParams.push(sort_by);
        }
        var url = '';
        for (var i = 0; i < Shopify.queryParams.length; i++) {
          url += encodeURIComponent(Shopify.queryParams[i].key) + '=' + Shopify.queryParams[i].value;
          if (i < Shopify.queryParams.length - 1) {
            url += '&';
          }
        }
        location.search = url;
      },1);
    });
  }
};
window.addEventListener("collectionSort", () => initCollectionSort());

// Grid or list view
var saveCollectionview = function(attribute, value) {
  const config = {
    method: 'POST',
    body: JSON.stringify({
      attributes: {
        [attribute]: value
      }
    }),
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      'Accept': 'application/javascript'
    }
  };
  fetch(routes.cart_update_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          handleErrorMessage(response.description);
          return;
        }
      })
      .catch((error) => {
        console.log("saveCollectionview error", error);
      });
}

var clearRangeInputs = function(minInput, maxInput) {
  var minInput = document.querySelector('#filter input#min'),
      maxInput = document.querySelector('#filter input#max');
  if (minInput && maxInput) {
    minInput.removeAttribute('name');
    maxInput.removeAttribute('name');
  }
}
var clearAllInputs = function() {
  clearRangeInputs();
  var inputs = document.getElementById('filter').querySelectorAll('input[type="checkbox"]:checked');
  inputs.forEach(function (el) {
    el.checked = false;
  });
}

window.addEventListener("collectionLoadMore", function (evt) {
  var collection_load_more = document.querySelectorAll('#load-more-button[data-next], #load-more-button[data-prev]');
  if (collection_load_more.length) {
    Array.from(collection_load_more).forEach(function (button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        var template = button.getAttribute('data-section'),
            collectionSection = document.getElementById('shopify-section-' + template),
            curr_products = collectionSection.querySelector('.results, .l4cl:not(.bls, .category)'),
            pagination_info = document.getElementById('load-more-info');
        if (button.getAttribute('data-next') != null) {
          var direction = 'next'
        } else {
          var direction = 'prev';
        }
        button.classList.add('loading');
        fetch(button.getAttribute('href'))
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                throw error;
              }
              return response.text();
            })
            .then((text) => {
              const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-' + template);
              var	new_products = resultsMarkup.querySelector('.results, .l4cl:not(.bls, .category)'),
                  new_button = resultsMarkup.querySelector('#load-more-button[data-'+ direction +'], #load-more-button[data-top]'),
                  new_pagination_info = resultsMarkup.querySelector('#load-more-info');

              if (direction == 'prev'){
                var lastScrollHeight = curr_products.scrollHeight;
              }
              if (curr_products && new_products) {
                window.requestAnimationFrame(() => {
                  const fragment = document.createDocumentFragment();
                  const children = Array.from(new_products.children);
                  
                  if (direction == 'next') {
                    children.forEach(el => fragment.appendChild(el));
                    curr_products.appendChild(fragment);
                  } else {
                    children.reverse().forEach(el => fragment.appendChild(el));
                    curr_products.insertBefore(fragment, curr_products.firstChild);
                  }

                  if (direction == 'next' && pagination_info && pagination_info.parentNode && new_pagination_info) {
                    pagination_info.parentNode.replaceChild(new_pagination_info, pagination_info);
                  }
                  if (button && button.parentNode && new_button) {
                    button.parentNode.replaceChild(new_button, button);
                  } else if (button && direction == 'prev') {
                    button.remove();
                  } else if (button) {
                    button.classList.remove('loading');
                  }
                  if (direction == 'prev'){
                    var scrollDiff = curr_products.scrollHeight - lastScrollHeight,
                        scrollTo = curr_products.scrollTop += scrollDiff;
                    window.scrollTo({
                      top: scrollTo,
                      behavior: 'instant',
                    });
                  }

                  const runReinit = () => {
                    window.requestAnimationFrame(() => {
                      if (typeof initRatings === 'function') {
                        initRatings(curr_products);
                      } else {
                        const ratingsEvtContainer = new CustomEvent("ratings", { detail: { container: curr_products } });
                        window.dispatchEvent(ratingsEvtContainer);
                      }

                      if (typeof initSemanticInput === 'function') {
                        initSemanticInput(curr_products);
                      } else {
                        const semanticInputEvtContainer = new CustomEvent("semanticInput", { detail: { container: curr_products } });
                        window.dispatchEvent(semanticInputEvtContainer);
                      }

                      window.dispatchEvent(productVariantsEvt);
                      
                      ajaxCart.init();
                      quickShop.init();

                      const deferredEvts = [
                        schemeTooltipEvt,
                        popupsEvt,
                        collectionLoadMoreEvt,
                        listScrollableEvt,
                        formZindexEvt,
                        semanticSelectEvt
                      ];

                      if (document.querySelectorAll('.l4cl.slider:not(.in-popup, .s4wi), .l4ft.slider:not(.in-popup, .s4wi)').length) {
                        deferredEvts.push(listCollectionSliderEvt);
                      }

                      setTimeout(() => {
                        deferredEvts.forEach(evt => window.dispatchEvent(evt));
                      }, 100);
                    });
                  };
                  
                  runReinit();
                });
              }
              window.history.replaceState({}, '', button.getAttribute('href'));
            })
            .catch((error) => {
              if (button) {
                button.classList.remove('loading');
              }
              console.log("collectionLoadMore error", error);
              throw error;
            });
      });
    });
  }
});

function saveLoadMoreAnchor() {
}

window.addEventListener("collectionSeoUpdate", async function (evt) {
  const seoUrl = window.location.href;
  const urlWithTimestamp = seoUrl.includes('?')
    ? `${seoUrl}&view=${Date.now()}`
    : `${seoUrl}?view=${Date.now()}`;

  try {
    const response = await fetch(urlWithTimestamp, { cache: "no-store" });
    const html = await response.text();
    const fetchedDoc = new DOMParser().parseFromString(html, "text/html");

    const newRobots = fetchedDoc.querySelector('meta[name="robots"]');
    const newHasNoindex = newRobots && newRobots.content && newRobots.content.includes("noindex");

    const currentRobots = document.querySelector('meta[name="robots"]');
    const currentHasNoindex = currentRobots && currentRobots.content.includes("noindex");

    if (newHasNoindex) {
      Array.from(document.getElementsByTagName('link')).forEach(el => {
          if (el.getAttribute('rel') === 'canonical') el.remove();
      });
    } else {
      const newCanonical = fetchedDoc.head.querySelector('link[rel="canonical"]');
      const currentCanonical = document.querySelector('link[rel="canonical"]');

      if (newCanonical) {
        const clone = newCanonical.cloneNode(true);

        if (currentCanonical) {
          currentCanonical.replaceWith(clone);
        } else {
          document.head.appendChild(clone);
        }

      } else if (currentCanonical) {
        currentCanonical.remove();
      }
    }

    if (newHasNoindex) {
      const clone = newRobots.cloneNode(true);

      if (currentRobots) {
        currentRobots.replaceWith(clone);
      } else {
        document.head.appendChild(clone);
      }

    } else if (currentRobots && currentHasNoindex) {
      currentRobots.remove();
    }

  } catch (error) {
    console.error("Error updating SEO content:", error);
  }

});

window.addEventListener("initFilters", function (evt) {
  initFilters();
});

function initFilters() {
  if (document.getElementById('filter') != null) {
    new_css('form-validation-css', window.filepaths['async_validation_css']);

    // Collectionpage: filters
    var debounceTimer;
    var processFilters = function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        var filter_form_template = filter_form.dataset.template;
        var collectionSection = document.getElementById('shopify-section-' + filter_form_template);
        filter_form.classList.add('processing');
        if (collectionSection.querySelector('.l4cl:not(.bls)')) {
          collectionSection.querySelector('.l4cl:not(.bls)').classList.add('processing');
        }
        var minInput = document.querySelector('#filter input#min'),
            maxInput = document.querySelector('#filter input#max');
        if ((minInput && maxInput) && minInput.value == minInput.getAttribute('min') && maxInput.value == maxInput.getAttribute('max')) {
          clearRangeInputs();
        }
        var filterFormData = new FormData(document.getElementById('filter'));
        var filterParams = new URLSearchParams(filterFormData).toString();
        const filterUrl = window.location.pathname + '?section_id=' + filter_form_template + '&' + filterParams;
        fetch(filterUrl)
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                throw error;
              }
              return response.text();
            })
            .then((text) => {
              const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-' + filter_form_template);
              const toggledLinkMore = filter_form.getElementsByClassName('link-more-clicked');
              window.requestAnimationFrame(() => {
                const newFilterForm = resultsMarkup.querySelector('#filter');
                if (newFilterForm && filter_form) {
                    const filterHeaders = filter_form.getElementsByTagName('h4');
                    Array.from(filterHeaders).forEach(function (el) {
                        if (el.hasAttribute('data-filter-toggle') && el.classList.contains('toggle')) {
                            const target = newFilterForm.querySelector('h4[data-filter-toggle="'+ el.dataset.filterToggle +'"]');
                            if (target) target.classList.add('toggle');
                        }
                    });

                    const fragment = document.createDocumentFragment();
                    Array.from(newFilterForm.childNodes).forEach(node => fragment.appendChild(node));
                    filter_form.replaceChildren(fragment);

                    var updated_anchors = filter_form.getElementsByTagName('li');
                    Array.from(updated_anchors).forEach(function (li) {
                        const labels = li.getElementsByTagName('label');
                        if (labels.length) {
                            const anchors = labels[0].getElementsByTagName('a');
                            if (anchors.length) {
                                anchors[0].classList.add('no-click');
                            }
                        }
                    });
                }

                const resultsContainer = collectionSection.querySelector('.results, .l4cl:not(.bls, .category)');
                const newResultsContainer = resultsMarkup.querySelector('.results, .l4cl:not(.bls, .category)');
                
                if (resultsContainer && newResultsContainer) {
                  const fragment = document.createDocumentFragment();
                  Array.from(newResultsContainer.childNodes).forEach(node => fragment.appendChild(node));
                  resultsContainer.replaceChildren(fragment);
                  
                  // Handle pagination blocks: both 'pages' (.n6pg) and 'load-more' (#load-more-info, .link-btn with #load-more-button)
                  // Find all pagination elements in old and new markup
                  const isPaginationElement = (el) => {
                    return el.classList.contains('n6pg') || 
                           el.id === 'load-more-info' || 
                           el.querySelector('#load-more-button') ||
                           (el.tagName === 'HR' && el.classList.contains('m25'));
                  };

                  const oldPaginationBlocks = Array.from(collectionSection.children).filter(isPaginationElement);
                  // If they are not direct children (e.g., inside another div), try more specific lookup
                  if (!oldPaginationBlocks.length) {
                    const possibleContainers = Array.from(collectionSection.querySelectorAll('.n6pg, #load-more-info, .link-btn, hr.m25'));
                    possibleContainers.forEach(el => {
                       if (isPaginationElement(el)) oldPaginationBlocks.push(el);
                    });
                  }

                  const newPaginationBlocks = Array.from(resultsMarkup.querySelectorAll('.n6pg, #load-more-info, .link-btn, hr.m25')).filter(isPaginationElement);

                  // Remove old pagination blocks
                  oldPaginationBlocks.forEach(el => el.remove());

                  // Add new pagination blocks maintaining their position relative to the results container
                  if (newPaginationBlocks.length) {
                    let lastAfter = resultsContainer;
                    newPaginationBlocks.forEach(newBlock => {
                      const clone = newBlock.cloneNode(true);
                      if (newResultsContainer.compareDocumentPosition(newBlock) & Node.DOCUMENT_POSITION_FOLLOWING) {
                        lastAfter.after(clone);
                        lastAfter = clone;
                      } else {
                        resultsContainer.before(clone);
                      }
                    });
                  }

                  const countElements = collectionSection.getElementsByClassName('hx');
                  const newCountElements = resultsMarkup.getElementsByClassName('hx');
                  if (countElements.length && newCountElements.length) {
                    Array.from(countElements).forEach((el, index) => {
                      if (newCountElements[index]) {
                        el.textContent = newCountElements[index].textContent;
                      }
                    });
                  }

                  const submitBtnContainer = collectionSection.getElementsByClassName('link-btn submit desktop-hide');
                  const newSubmitBtnContainer = resultsMarkup.getElementsByClassName('link-btn submit desktop-hide');
                  if (submitBtnContainer.length && newSubmitBtnContainer.length) {
                    const submitBtn = submitBtnContainer[0].getElementsByTagName('a');
                    const newSubmitBtn = newSubmitBtnContainer[0].getElementsByTagName('a');
                    if (submitBtn.length && newSubmitBtn.length) {
                      submitBtn[0].textContent = newSubmitBtn[0].textContent;
                    }
                  }
                } else {
                  collectionSection.innerHTML = resultsMarkup.innerHTML;
                }

                filter_form.classList.remove('processing');
                if (collectionSection.querySelector('.l4cl:not(.bls)')) {
                  collectionSection.querySelector('.l4cl:not(.bls)').classList.remove('processing');
                }

                // check if drawer is enabled
                const sidebarGlobal = document.querySelector('.filters-aside-initialized');
                if (sidebarGlobal) {
                  // replace HTML
                  const drawerMarkup = resultsMarkup.querySelector('#filters-aside')
                  if (drawerMarkup) {
                    const fragment = document.createDocumentFragment();
                    Array.from(drawerMarkup.childNodes).forEach(node => fragment.appendChild(node));
                    sidebarGlobal.replaceChildren(fragment);
                    sidebarGlobal.classList.add('processed-filter');
                  }

                  // remove section filters there is always one.
                  const oldFilters = document.querySelector('#filters-aside:not(.filters-aside-initialized)');
                  if (oldFilters) oldFilters.remove();
                }
                linkMore();
                Array.from(toggledLinkMore).forEach(function (el) {
                  const link = collectionSection.querySelector('ul[data-filter-toggle="'+ el.dataset.filterToggle +'"] a.link-more');
                  if (link) link.click();
                });
                if (document.querySelector('.collection-wrapper')) {
                  document.querySelector('.collection-wrapper').scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }

                window.requestAnimationFrame(() => {
                  const resultsContainer = collectionSection.querySelector('.results, .l4cl:not(.bls, .category)');
                  
                  if (typeof initRatings === 'function') {
                    initRatings(resultsContainer);
                  } else {
                    const ratingsEvtContainer = new CustomEvent("ratings", { detail: { container: resultsContainer } });
                    window.dispatchEvent(ratingsEvtContainer);
                  }

                  if (typeof initSemanticInput === 'function') {
                    initSemanticInput(resultsContainer);
                  } else {
                    const semanticInputEvtContainer = new CustomEvent("semanticInput", { detail: { container: resultsContainer } });
                    window.dispatchEvent(semanticInputEvtContainer);
                  }

                  const priorityEvts = [
                    collectionSeoUpdate,
                    collectionSortEvt,
                    rangeSliderEvt,
                    initFiltersEvt,
                    filtersEvt,
                    modulePanelEvt,
                    navAsideEvt
                  ];
                  
                  forceFormFilterRender = true;

                  let eventIndex = 0;
                  const runNextPriorityEvent = () => {
                    if (eventIndex < priorityEvts.length) {
                      window.dispatchEvent(priorityEvts[eventIndex]);
                      eventIndex++;
                      window.requestAnimationFrame(runNextPriorityEvent);
                    } else {
                      ajaxCart.init();
                      quickShop.init();

                      const deferredEvts = [
                        semanticSelectEvt,
                        schemeTooltipEvt,
                        popupsEvt,
                        collectionLoadMoreEvt,
                        listScrollableEvt,
                        modulePanelAnchorEvt,
                        productcardVariantsEvt,
                        heightLimitEvt
                      ];

                      if (document.querySelectorAll('.l4cl.slider:not(.in-popup, .s4wi), .l4ft.slider:not(.in-popup, .s4wi)').length) {
                        deferredEvts.push(listCollectionSliderEvt);
                      }

                      setTimeout(() => {
                        deferredEvts.forEach(evt => window.dispatchEvent(evt));
                        window.dispatchEvent(semanticSelectEvt);
                      }, 100);
                    }
                  };
                  
                  window.requestAnimationFrame(runNextPriorityEvent);
                  window.check_limit_event();
                });
              });

              history.pushState({ filterParams }, '', `${window.location.pathname}${filterParams && '?'.concat(filterParams)}`);
            })
            .catch((error) => {
              filter_form.classList.remove('processing');
              if (collectionSection.querySelector('.l4cl:not(.bls)')) {
                collectionSection.querySelector('.l4cl:not(.bls)').classList.remove('processing');
              }
              console.log("processFilters error", error);
              throw error;
            });
      }, 150);
    };

    let filter_form = document.getElementById('filter');
    if (!filter_form.hasAttribute('data-filters-initialized')) {
        filter_form.addEventListener('click', function(e) {
            const el = e.target.closest('a.remove-all, a.clear-range');
            if (el) {
                e.preventDefault();
                if (el.classList.contains('remove-all')) {
                    clearAllInputs();
                } else {
                    clearRangeInputs();
                }
                processFilters();
            }
        });

        filter_form.addEventListener('change', function(e) {
            const el = e.target.closest('input');
            if (el) {
                processFilters();
            }
        });

        filter_form.setAttribute('data-filters-initialized', 'true');
    }

    var form_filter_input_anchors = filter_form.getElementsByTagName('li');
    Array.from(form_filter_input_anchors).forEach(function (li) {
      const labels = li.getElementsByTagName('label');
      if (labels.length) {
          const anchors = labels[0].getElementsByTagName('a');
          if (anchors.length) {
              anchors[0].classList.add('no-click');
          }
      }
    });

    var layout = document.getElementById('filter').dataset.drawer;
    var filters = document.querySelector('.collection-wrapper').dataset.filters;
    if ( (filtersDrawerContent && layout === 'static') || (!filters && layout === 'drawer') ) {
      document.querySelector('#root .filters-aside-initialized').remove();
      hidePanels();
      return
    }

    var filtersDrawerContent = document.querySelector('#filters-aside');
    if (layout === 'drawer') {
      var editor = filtersDrawerContent.dataset.editor
      if(!document.querySelector('#root .filters-aside-initialized')){
        document.querySelector('#root').appendChild(filtersDrawerContent);
        filtersDrawerContent.classList.add('filters-aside-initialized');
      } else {
        if (editor) {
          if(filtersDrawerContent.classList.contains('inv')){
            document.querySelector('#root .filters-aside-initialized').classList.add('inv')
          } else {
            document.querySelector('#root .filters-aside-initialized').classList.remove('inv')
          }
          if (!document.querySelector('#root .filters-aside-initialized').classList.contains('processed-filter')){
            // processFilters();
          }
          document.querySelector('#root .filters-aside-initialized').classList.remove('processed-filter');
        }
      }
      window.dispatchEvent(navAsideEvt);
    }
  }
};
let forceFormFilterRender = false;
const initFiltersBehavior = () => {
  // .f8sr (collection)
  var form_sort = document.getElementsByClassName('f8sr'),
    form_sort_list_view,
    form_sort_list_inline;

  function clearSortForm() {
    Array.from(form_sort).forEach((el) => {
      el.classList.remove('fixed');
      html_tag.classList.remove('f8sr-fixed');
    });
  }

  if (form_sort.length) {
    Array.from(form_sort).forEach(function (form_cont) {
      html_tag.classList.add('t1cl');
      if (form_cont.classList.contains('mobile-sticky') || form_cont.classList.contains('sticky')) {
        if (form_cont.hasAttribute('data-f8sr-initialized')) return;
        form_cont.setAttribute('data-f8sr-initialized', 'true');

        const trickDiv = createElementWithClass('div', 'offset-dist');
        const trickDist = createElementWithClass('div', 'inner-dist');

        let cachedTrickHeight = 0;
        function updateTrickDistHeight(div) {
          const currentHeight = form_cont.offsetHeight;
          if (!div.hasHeight || cachedTrickHeight !== currentHeight) {
            cachedTrickHeight = currentHeight;
            window.requestAnimationFrame(() => {
              div.style.height = currentHeight + 'px';
              root_styles.style.setProperty('--f8sr_height', currentHeight + 'px');
              div.hasHeight = true;
            });
          }
        }

        let updateSearchHeightExecuted = false;
        let cachedSearchHeight = 0;
        function updateSearchHeight() {
          if (search_id && search_id.clientHeight > 0) {
            const currentHeight = search_id.clientHeight;
            if (!updateSearchHeightExecuted || cachedSearchHeight !== currentHeight) {
              cachedSearchHeight = currentHeight;
              updateSearchHeightExecuted = true;
              window.requestAnimationFrame(() => {
                root_styles.style.setProperty('--search_height', currentHeight + 'px');
              });
            }
          }
        }

        function createEventListeners(element) {
          const updateAll = () => {
            updateTrickDistHeight(element);
            updateSearchHeight();
          };

          window.addEventListener('scroll', throttle(updateAll, 100), { passive: true });
          window.addEventListener('resize', throttle(() => {
            updateTrickDistHeight(element);
            updateSearchHeightExecuted = false;
            updateSearchHeight();
          }, 500), { passive: true });
          window.addEventListener('touchstart', throttle(updateAll, 200), { passive: true });
          window.addEventListener('keyup', throttle(updateAll, 200));
        }

        // function createEventListeners(element) {
        //   const update = () => {
        //     updateTrickDistHeight(element);
        //     updateSearchHeight();
        //   };
        //
        //   const updateResize = () => {
        //     updateTrickDistHeight(element);
        //     updateSearchHeightExecuted = false;
        //     updateSearchHeight();
        //   };
        //
        //   const throttledScroll = throttle(update, 100);
        //   const throttledTouch = throttle(update, 200);
        //   const throttledKeyup = throttle(update, 200);
        //   const throttledResize = throttle(updateResize, 500);
        //
        //   window.addEventListener('scroll', throttledScroll, { passive: true });
        //   window.addEventListener('touchstart', throttledTouch, { passive: true });
        //   window.addEventListener('keyup', throttledKeyup);
        //   window.addEventListener('resize', throttledResize);
        // }

        const observer = new IntersectionObserver(
          ([e]) => {
            const boundingRect = e.boundingClientRect;

            if (e.isIntersecting) {
              //console.log('Element - on screen.');
              const el_mod = form_cont.classList.contains('sticky') ? e.target.nextElementSibling : form_cont;
              el_mod.classList.remove('fixed');
              html_tag.classList.remove('f8sr-fixed');
            } else {
              const el_mod = form_cont.classList.contains('sticky') ? e.target.nextElementSibling : form_cont;
              if (boundingRect.top < 0) {
                //console.log('Element - above screen.');
                el_mod.classList.add('fixed');
                html_tag.classList.add('f8sr-fixed');
              }
              if (boundingRect.bottom >= window.innerHeight) {
                //console.log('Element - below screen.');
                el_mod.classList.remove('fixed');
                html_tag.classList.remove('f8sr-fixed');
              }
            }
          }, {
            threshold: [0, 1],
            rootMargin: "0px 0px 0px 0px"
          }
        );

        if (form_cont.classList.contains('sticky')) {
          const trg = form_cont;

          trickDist.classList.add('before-f8sr');
          form_cont.after(trickDiv);
          form_cont.before(trickDist);

          createEventListeners(form_cont.nextElementSibling);

          observer.observe(form_cont.previousElementSibling);
        } else if (form_cont.classList.contains('mobile-sticky') && form_cont.classList.contains('mobile-compact')) {
          const trg = form_cont.querySelector('.link-btn');

          if (trg) {
            if (trg.classList.contains('mobile-hide')) {
              form_cont.classList.add('btn-mobile-hide');
            }
          }

          form_cont.prepend(trickDiv);
          form_cont.prepend(trickDist);

          createEventListeners(form_cont.querySelector('.inner-dist'));

          observer.observe(form_cont.querySelector('.offset-dist'));
          if (trg !== undefined && trg !== null && !form_cont.querySelector('.link-btn.clone')) {
            const clone_me = trg.cloneNode(true);
            clone_me.classList.add('clone');
            insertAfter(trg, clone_me);
          }
        }
      }
      form_sort_list_view = form_cont.getElementsByClassName('l4vw');
      form_sort_list_inline = form_cont.getElementsByClassName('l4in');

      if (form_sort_list_view.length) {
        Array.from(form_sort_list_view).forEach(function (el) {
          html_tag.classList.add('t1cl');
          const ariaControls = el.getAttribute('aria-controls');
          if (ariaControls !== null) {
            var im = el,
              view_item = el.getElementsByTagName('li'),
              view_list = document.getElementById(ariaControls);
            
            const icons = el.getElementsByTagName('i');
            Array.from(icons).forEach(function (icon) {
              const iconClass = icon.className;
              if (iconClass.indexOf('icon-view-') !== -1) {
                icon.parentElement.addEventListener('click', function (e) {
                  Array.from(view_item).forEach(function (item) {
                    item.classList.remove('active');
                  });
                  if (iconClass.indexOf('icon-view-list') !== -1) {
                    saveCollectionview('collection_view', 'list');
                    view_list.classList.add('list');
                    form_cont.classList.add('list');
                    
                    Array.from(icons).forEach(function (i) {
                        if (i.className.indexOf('icon-view-list') !== -1) {
                            i.closest('li').classList.add('active');
                        }
                    });

                    const linkMores = view_list.getElementsByClassName('link-more');
                    Array.from(linkMores).forEach(function (linkMore) {
                      handleInfoAndList(linkMore);
                    });
                  }
                  if (iconClass.indexOf('icon-view-grid') !== -1) {
                    saveCollectionview('collection_view', 'grid');
                    view_list.classList.remove('list');
                    form_cont.classList.remove('list');
                    
                    Array.from(icons).forEach(function (i) {
                        if (i.className.indexOf('icon-view-grid') !== -1) {
                            i.closest('li').classList.add('active');
                        }
                    });
                  }
                  e.preventDefault();
                });
              }
            });
          }
        });
      }

      if (form_sort_list_inline.length) {
        Array.from(form_sort_list_inline).forEach(function (el) {
          const ariaControls = el.getAttribute('aria-controls');
          if (ariaControls !== null) {
            var im = el,
              view_list = document.getElementById(ariaControls);
            const inputs = el.getElementsByTagName('input');
            Array.from(inputs).forEach(function (input) {
              input.parentElement.addEventListener('click', function (e) {
                removeClassByPrefix(view_list, 'w');
                const width = input.getAttribute('data-width');
                saveCollectionview('collection_grid_view', width);
                const classes = width.split(' ');
                classes.forEach(className => {
                  view_list.classList.add(className);
                });
              });
            });
          }
        });
      }
    });
  }

  // .f8fl (collection)
  const form_filter = document.getElementsByClassName('f8fl');
  let formFilterRendered = false;
  if (form_filter.length) {
    html_tag.classList.add('t1cl');
    function renderFormFilter() {
      if (!formFilterRendered) {
        Array.from(form_filter).forEach(function (el) {
          append_url(el, 'Close', 'f8fl-toggle');

          const elementId = el.getAttribute('id');

          if (elementId) {
            Array.from(document.querySelectorAll(`[href="#${elementId}"]`)).forEach(link => {
              link.classList.add('f8fl-toggle');
            });
          }
          const headers = [];
          ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].forEach(tag => {
              const elements = el.getElementsByTagName(tag);
              for (let i = 0; i < elements.length; i++) headers.push(elements[i]);
          });
          const h4cl = el.getElementsByClassName('h4');
          for (let i = 0; i < h4cl.length; i++) headers.push(h4cl[i]);

          headers.forEach(function (h) {
            append_url(h, 'Close', 'header-toggle');
          });
        });
        Array.from(document.getElementsByClassName('f8fl-toggle')).forEach(function (el) {
          el.setAttribute('aria-controls', 'filter');
        });
        formFilterRendered = true;
      }
    }

    function handleFilterClick(event) {
      renderFormFilter();
      if (event.target.matches('a[aria-controls="filter"], a[aria-controls="filter"] *')) {
        html_tag.classList.add('has-filters');
        if (!html_tag.classList.contains('f8fl-open')) {
          hidePanels();
          html_tag.classList.add('f8fl-open');
        } else {
          html_tag.classList.remove('f8fl-open');
        }
        if (event.target.closest('.m6pn') !== null) {
          overlayClose();
        }
        getStickyFooters();
        new_css('css-filters', window.filepaths['async_filters_css']);
        new_css('css-search', window.filepaths['async_search_css']);
        event.preventDefault();
      }
    }

    function handleFilterSub(event) {
      if (event.target.matches('.f8fl a.header-toggle, .f8fl a.header-toggle *')) {
        const closestH = event.target.closest('h1, h2, h3, h4, .h4, h5, h6');
        toggle_dropdowns_simple(closestH);
        if (closestH.classList.contains('toggle') && typeof runPaddingsForInputs === 'function') {
          Array.from(nextUntil(closestH, 'h1, h2, h3, h4, .h4, h5, h6')).forEach(function (el) {
            Array.from(el.querySelectorAll('[class*="input-"][class*="fix"]')).forEach(runPaddingsForInputs);
          });
        }
        if (!closestH.hasAttribute('id')) {
          event.preventDefault();
        }
      }
    }
    if (forceFormFilterRender) {
      renderFormFilter();
      forceFormFilterRender = false;
    }
    if (!window.formFilterListenersAdded) {
      document.addEventListener('click', handleFilterClick);
      document.addEventListener('click', handleFilterSub);
      document.addEventListener('keyup', function (event) {
        if (event.key === ' ') {
          handleFilterClick(event);
          handleFilterSub(event);
        }
      });
      window.formFilterListenersAdded = true;
    }
  }
};
window.addEventListener("filters", initFiltersBehavior);

// .n6as (collection)
window.addEventListener("navAside", function(evt) {
  const nav_aside = document.querySelectorAll('.n6as a.toggle:not(.n6as-initalized)');
  if (nav_aside.length) {
    nav_aside.forEach(function (el) {
      el.classList.add('n6as-initalized');
      el.addEventListener('click', function (e) {
        toggle_dropdowns_simple(el.parentElement);
        e.preventDefault();
      });
    });
  }
});

// .input-range (collection)
window.addEventListener("rangeSlider", function(evt) {
  const input_range = document.getElementsByClassName('input-range');
  if (input_range.length) {
    const input_range_steps = document.getElementsByClassName('input-range-steps');
    loadRes(window.filepaths['plugin_sliders_js'], function () {
      new_css('form-sliders-css', window.filepaths['async_ui_sliders_css']);
      Array.from(input_range).forEach(el => {
        if (!el.classList.contains('slider-is-here')) {
          const rangeInner = createElementWithClass('div', 'range-inner');
          el.appendChild(rangeInner);

          const dataMin = el.querySelector('input[min]');
          const dataMax = el.querySelector('input[max]');
          const dataEl = el.querySelector('input');
          const evt = new Event('change', { bubbles: true });
          let optConnect = true;
          let optStart = [parseFloat(dataMin.value), parseFloat(dataMax.value)];
          let isTooltip = false;

          if (el.classList.contains('single')) {
            optConnect = 'lower';
            optStart = parseFloat(dataEl.value);
          }

          if (el.classList.contains('tip')) {
            isTooltip = true;
          }

          noUiSlider.create(rangeInner, {
            start: optStart,
            connect: optConnect,
            step: 1,
            direction: global_dir[0],
            range: {
              'min': [parseFloat(dataMin.getAttribute('min'))],
              'max': [parseFloat(dataMax.getAttribute('max'))]
            },
            tooltips: isTooltip,
            format: {
              to: value => Math.round(value),
              from: value => Math.round(value)
            }
          });

          rangeInner.noUiSlider.on('update', (values, handle) => {
            const target = handle ? dataMax : dataMin;
            target.value = parseFloat(values[handle]).toFixed();
          });

          rangeInner.noUiSlider.on('change', (handle) => {
            const target = handle ? dataMax : dataMin;
            target.dispatchEvent(evt);
          });

          rangeInner.querySelectorAll('[role="slider"]').forEach(em => {
            em.setAttribute('aria-label', 'slider');
          });

          el.querySelectorAll('input').forEach(input => {
            input.addEventListener('blur', () => {
              const value = input.value.trim();
              if (value !== '') {
                const numValue = parseFloat(value);
                if (input.hasAttribute('min')) {
                  rangeInner.noUiSlider.set([numValue, null]);
                } else if (input.hasAttribute('max')) {
                  rangeInner.noUiSlider.set([null, numValue]);
                }
              }
            });
          });
          el.classList.add('slider-is-here');
        }
      });

      if (input_range_steps.length) {
        Array.from(input_range_steps).forEach(function (el) {
          if (!el.classList.contains('steps-is-here')) {
            Array.from(el.children).forEach(child => {
              const wrapper = document.createElement('span');
              wrapper.className = 'inner';
              while (child.firstChild) {
                wrapper.appendChild(child.firstChild);
              }
              child.appendChild(wrapper);
            });
            const prevEl = el.previousElementSibling;
            if (prevEl && prevEl.classList.contains('input-range')) {
              const cloneMe = el.cloneNode(true);
              cloneMe.removeAttribute('class');
              cloneMe.classList.add('range-cloned');

              const noUiBase = prevEl.querySelector('.noUi-base');
              if (noUiBase) {
                noUiBase.appendChild(cloneMe);
              }
            }
            el.classList.add('steps-is-here');
          }
        });
      }
    }, 'sliders-loaded');
  }
});

initCollectionSort();
window.dispatchEvent(rangeSliderEvt);
initFilters();
initFiltersBehavior();

document.addEventListener('click', (e) => {
  const link = e.target.closest('#collection figure > a, .m6cl .results > div a, .m6cl .results > .l4ne a');
  if (link && link.hasAttribute('href')) {
    localStorage.setItem('loadMoreItemClicked', link.getAttribute('href'));
  }
});

const deferInitCollection = () => {
  const events = [];

  if (window.location.pathname.includes('collections') || window.location.pathname.includes('search')) {
    events.push(collectionSeoUpdate);
  }

  events.push(collectionLoadMoreEvt);
  events.push(navAsideEvt);

  events.forEach((evt, index) => {
    setTimeout(() => {
      window.dispatchEvent(evt);
    }, 100 * (index + 1));
  });
};

setTimeout(deferInitCollection, 50);
